import styled from 'styled-components';

export const ItemsOuterContainer = styled.div`
  display: flex;
  overflow-x: scroll;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;
export const ItemsContainer = styled.div`
  display: flex;
  padding-left: 16px;
  padding-right: 16px;
  gap: 32px;
  position: relative;
  margin-left: auto;
  margin-right: auto;

  /* ligne de séparation */
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 16px;
    height: 2px;
    background: ${({ theme }) => theme.palette.common.BACKGROUND_3};
    width: calc(100% - 32px);
    transform: translateY(-50%);
  }
`;
